<template>
  <div class='surveys-view mt-3'>
    <b-card no-body>
      <b-tabs v-model="tabIndex" pills card>
        <b-tab @click="setBreadcrumbTabsName('Pesquisas')" no-body title='Pesquisas'>
          <div v-if='tabIndex === 0' class='m-2'>
            <survey />
          </div>
        </b-tab>

        <b-tab @click="setBreadcrumbTabsName('Frequência de uso')" no-body title='Frequência de uso'>
          <div v-if='tabIndex === 1' class='m-2'>
            <frequency-use />
          </div>
        </b-tab>

        <b-tab @click="setBreadcrumbTabsName('Agentes adicionados')" no-body title='Agentes adicionados'>
          <div v-if='tabIndex === 2' class='m-2'>
            <chemical-agents-researched />
          </div>
        </b-tab>

        <b-tab @click="setBreadcrumbTabsName('Assinaturas')" no-body title='Assinaturas'>
          <div v-if='tabIndex === 3' class='m-2'>
            <logs-assinatura-planos />
          </div>
        </b-tab>

        <b-tab @click="setBreadcrumbTabsName('Tags enviadas')" no-body title='Tags enviadas'>
          <div v-if='tabIndex === 4' class='m-2'>
            <activecampaign-tag-sent/>
          </div>
        </b-tab>

        <b-tab @click="setBreadcrumbTabsName('SMS enviados')" no-body title='SMS enviados'>
          <div v-if='tabIndex === 5' class='m-2'>
            <s-m-s-sent-log/>
          </div>
        </b-tab>

        <b-tab @click="setBreadcrumbTabsName('Pesquisa de agente')" no-body title='Pesquisa de agente'>
          <div v-if='tabIndex === 6' class='m-2'>
            <SearchAgents/>
          </div>
        </b-tab>

        <b-tab @click="setBreadcrumbTabsName('UTM de cadastro')" no-body title='UTM cadastro'>
          <div v-if='tabIndex === 7' class='m-2'>
            <UserUTMTable/>
          </div>
        </b-tab>

        <b-tab @click="setBreadcrumbTabsName('UTM de compra')" no-body title='UTM compra'>
          <div v-if='tabIndex === 8' class='m-2'>
            <PlansUTMTable/>
          </div>
        </b-tab>

        <b-tab @click="setBreadcrumbTabsName('Empresas')" no-body title='Empresas'>
          <div v-if='tabIndex === 9' class='m-2'>
            <CompaniesTable/>
          </div>
        </b-tab>
        <b-tab @click="setBreadcrumbTabsName('FDS/FISPQ dos produtos')" no-body title='FDS/FISPQ dos produtos'>
          <div v-if='tabIndex === 10' class='m-2'>
            <AttachmentTable/>
          </div>
        </b-tab>
        <b-tab @click="setBreadcrumbTabsName('Arquivos importados')" no-body title='Arquivos importados'>
          <div v-if='tabIndex === 11' class='m-2'>
            <ImportedFile/>
          </div>
        </b-tab>
        <b-tab @click="setBreadcrumbTabsName('Feedback')" no-body title='Feedback'>
          <div v-if='tabIndex === 12' class='m-2'>
            <FeedbackTable/>
          </div>
        </b-tab>
        <b-tab @click="setBreadcrumbTabsName('Sugestões de melhorias (Aba Limites prevencionistas)')" no-body title='Sugestões de melhorias (Limites prevencionistas)'>
          <div v-if='tabIndex === 13' class='m-2'>
            <SuggestionsImprovementsTable/>
          </div>
        </b-tab>
        <b-tab @click="setBreadcrumbTabsName('Modal de ciência das informações e declaro estar de acordo ao continuar (Aba Limites prevencionistas)')" no-body title='Modal de ciência das informações e declaro estar de acordo ao continuar (Aba Limites prevencionistas)'>
          <div v-if='tabIndex === 14' class='m-2'>
            <UserAwareOfInformationTable/>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import Survey from '@/components/Surveys/Survey'
import FrequencyUse from '@/components/FrequencyUse/FrequencyUse'
import LogsAssinaturaPlanos from '@/views/LogsAssinaturaPlanos'
import ChemicalAgentsResearched from '@/components/ChemicalAgentsResearched/ChemicalAgentsResearched'
import SearchAgents from '@/components/SearchAgents/SearchAgents'
import ActivecampaignTagSent from '@/components/ActivecampaignTagSent/ActivecampaignTagSent'
import SMSSentLog from '@/components/SMSSentLog/SMSSentLog'
import { mapActions } from 'vuex'
import UserUTMTable from '@/components/UTM/UserUTMTable.vue'
import PlansUTMTable from '@/components/UTM/PlansUTMTable.vue'
import CompaniesTable from '@/components/ManageCompanies/CompaniesTable.vue'
import AttachmentTable from '@/components/ProductLegalConsultation/AttachmentTable.vue'
import ImportedFile from '@/views/ImportedFile.vue'
import FeedbackTable from '@/components/Feedback/FeedbackTable.vue'
import SuggestionsImprovementsTable from '@/components/SuggestedImprovement/SuggestionsImprovementsTable.vue'
import UserAwareOfInformationTable from '@/components/UserAwareOfInformation/UserAwareOfInformationTable.vue'

export default {
  name: 'Surveys',
  data() {
    return {
      tabIndex: 0,
      breadcrumbTabsName: 'Pesquisas'
    }
  },
  components: {
    ImportedFile,
    FeedbackTable,
    UserAwareOfInformationTable,
    SuggestionsImprovementsTable,
    PlansUTMTable,
    AttachmentTable,
    UserUTMTable,
    Survey,
    FrequencyUse,
    ChemicalAgentsResearched,
    ActivecampaignTagSent,
    LogsAssinaturaPlanos,
    SMSSentLog,
    SearchAgents,
    CompaniesTable,
  },
  computed: {},
  methods: {
    ...mapActions('breadcrumb', {
      setBreadcrumb: 'setBreadcrumb',
    }),

    setBreadcrumbTabsName(breadcrumbTabsName){
      this.breadcrumbTabsName = breadcrumbTabsName;
      const breadcrumb = {
        page: 'Relatórios',
        subPage: {
          name: 'Relatórios',
          active: false
        },
        tabs: [
          {
            name: this.breadcrumbTabsName,
            active: true
          }
        ]
      }
      this.setBreadcrumb(breadcrumb)
    }
  },
  created() {
    this.setBreadcrumbTabsName('Pesquias')
  },
  watch: {}
}
</script>

<style lang='scss' scoped>

</style>
